<img src="assets/logo.svg" alt="Maintenance" class="img-fluid" />
<div>
    <p>Sorry for the inconvenience but we&rsquo;re performing some maintenance at the moment</p>
    <p>We&rsquo;ll be back online soon!</p>
    <round-progress [current]="progress" [max]="150" [radius]="60" [stroke]="20" color="var(--bd-green-colour)" [responsive]="false" [rounded]="true" style="width: 25vw; height: 25vw; margin: 0 auto;"></round-progress>
</div>
